<template lang="pug">
.card-holder
  .stripe-card
    div(ref='card')
    b-form-invalid-feedback(:force-show='!!error')
      | {{ error }}
</template>

<script>
export default {
  name: 'Stripe',
  data() {
    return {
      card: null,
      stripe: null,
      error: null,
      currentStripeKey: null,
    };
  },
  props: {
    currency: String,
  },
  watch: {
    currency(newVal) {
      const newStripeKey = newVal === 'CAD'
        ? process.env.VUE_APP_STRIPE_PUBLIC_CA_KEY
        : process.env.VUE_APP_STRIPE_PUBLIC_KEY;

      if (this.currentStripeKey !== newStripeKey) {
        this.recreateStripeCard(newStripeKey);
      }
    },
  },
  mounted() {
    this.createStripe();
  },
  beforeDestroy() {
    if (this.card) {
      this.card.destroy();
    }
  },
  methods: {
    createStripe() {
      let stripeKey = process.env.VUE_APP_STRIPE_PUBLIC_KEY;
      if (this.currency === 'CAD') {
        stripeKey = process.env.VUE_APP_STRIPE_PUBLIC_CA_KEY;
      }
      this.currentStripeKey = stripeKey;

      // eslint-disable-next-line
      this.stripe = Stripe(stripeKey);
      const elements = this.stripe.elements();
      const style = {
        iconStyle: 'solid',
        style: {
          base: {
            color: '#878b87',
            fontSmoothing: 'antialiased',
            fontSize: '14px',
            '::placeholder': {
              color: '#aab7c4',
            },
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a',
          },
        },
      };
      this.card = elements.create('card', style);
      this.card.mount(this.$refs.card);
      this.card.on('change', ({ error }) => {
        this.error = error ? error.message : null;
      });
    },
    recreateStripeCard(newStripeKey) {
      if (this.card) {
        this.card.destroy();
      }

      this.currentStripeKey = newStripeKey;
      // eslint-disable-next-line
      this.stripe = Stripe(newStripeKey);
      const elements = this.stripe.elements();
      const style = {
        iconStyle: 'solid',
        style: {
          base: {
            color: '#878b87',
            fontSmoothing: 'antialiased',
            fontSize: '14px',
            '::placeholder': {
              color: '#aab7c4',
            },
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a',
          },
        },
      };
      this.card = elements.create('card', style);
      this.card.mount(this.$refs.card);
      this.card.on('change', ({ error }) => {
        this.error = error ? error.message : null;
      });
    },
  },
};
</script>
